// state
export const state = {
  status: false,
};

// mutations
export const mutations = {
  SET_PRINTER_STATUS: (state, data) => {
    state.status = data;
  },
};

// actions
export const actions = {
  setStatus({ commit }, payload) {
    commit("SET_PRINTER_STATUS", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
